import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "./Collectionspage.css";

function CollectionsPage() {
  const partnerTypes = [
    {
      title: "Mind & Emotional Wellness Professionals",
      audience: "( for psychologists, therapists, counsellors )",
      description: "Supporting calm, safe and grounding environments.",
    },
    {
      title: "Meditation & Healing Practitioners",
      audience:
        "( for sound healers, Reiki, breathwork, yoga nidra, spiritual facilitators )",
      description: "Crafting intentional sensory experiences.",
    },
    {
      title: "Wellness Sanctuaries",
      audience: "( for spas, retreats, wellness centres )",
      description:
        "Elevating rest, relaxation, and restorative rituals.",
    },
    {
      title: "Mindful Movement Studios",
      audience: "( for yoga, pilates, meditation studios )",
      description: "Creating atmosphere for deeper presence.",
    },
    {
      title: "Intentional Hospitality Spaces",
      audience: "( for boutique cafés, premium stays, Airbnbs, resorts )",
      description:
        "Creating thoughtful ambience for memorable experiences.",
    },
    {
      title: "Corporate Wellness & Community Spaces",
      audience:
        "( for offices, coworking spaces, employee wellbeing initiatives )",
      description: "Supporting moments of pause and reset.",
    },
    {
      title: "Curators of Meaningful Gifting",
      audience: "( for event planners, gifting companies, luxury hampers)",
      description: "curated sensory gifting experiences.",
    },
  ];

  const partnerBenefits = [
    "Exclusive partner pricing",
    "Custom scent recommendations for your space",
    "Private-label and co-branded gifting options",
    "Bulk and recurring order support",
    "Curated fragrances based on mood and atmosphere",
    "Wellness-centred sensory experiences",
    "Priority access to launches and seasonal collections",
    "Signature scenting for retreats and spas*",
  ];

  return (
    <>
      <Header />

      <main className="about-page">
        {/* HERO */}
        <section className="collab-hero">
          <div className="about-hero-content">
            {/* <span className="about-eyebrow">Curated Collabs</span> */}

            {/* <h1>Thoughtfully Crafted for Meaningful Spaces</h1>

            <p className="collab-subtitle">
              Crafted for spaces that nurture wellbeing.
            </p> */}
          </div>
        </section>

        <section className="about-story">
          {/* INTRODUCTION */}
          <div className="about-section">
            <span className="about-eyebrow">Crafted for spaces that nurture wellbeing</span>
            <h2>Thoughtfully Crafted for Meaningful Spaces</h2>
            <p>
              At Aethearia, we believe atmosphere shapes experience.
            </p>

            <p>
              Whether it is a therapy session, meditation practice, wellness retreat, spa ritual, or intentional hospitality — scent and ambience quietly influence how people feel, open up, relax, and reconnect.
            </p>

            <p>
              We partner with professionals and spaces that prioritize wellbeing, emotional comfort, mindfulness, and elevated experiences.
            </p>
          </div>

          {/* WHY PARTNER */}
          <div className="about-section">
            <h2>Why Partner with Aethearia?</h2>

            <p>
              A calming space is never created through visuals alone.
            </p>

            <p>
              The warmth of a flame, the subtle presence of fragrance, and the emotional atmosphere of a space can deeply influence how people feel — helping them feel grounded, comforted, safe, present, or restored.
            </p>

            <p>
             Inspired by sensory wellness, Indian rituals of flame, and modern understanding of scent psychology, Aethearia candles are thoughtfully crafted to complement experiences centred around wellbeing, healing, mindfulness, and meaningful human connection.
            </p>

            <p>
              From quiet therapy rooms to luxury wellness retreats,
              intentional spaces deserve intentional atmosphere.
            </p>
          </div>

          {/* PARTNER TYPES */}
         <div className="about-section">
  <h2>Who Can Partner with Us?</h2>

  <div className="collab-partner-list">
    {partnerTypes.map((partner, index) => (
      <div className="collab-partner-item" key={partner.title}>
        <h3>
          <span className="collab-card-number">
            {String(index + 1).padStart(2, "0")}
          </span>

          {partner.title}
        </h3>

        <div className="collab-answer">
          <p  style={{textAlign:"left"}} className="collab-audience">{partner.audience}</p>

          <p style={{textAlign:"left"}}>{partner.description}</p>
        </div>
      </div>
    ))}
  </div>
</div>
          {/* BENEFITS */}
          <div className="about-section">
            <h2>Partner Benefits</h2>

            <div className="collab-benefits-grid">
              {partnerBenefits.map((benefit) => (
                <div className="collab-benefit-item" key={benefit}>
                  <span className="collab-benefit-icon">✦</span>
                  <p className="text-left benefit ">{benefit}</p>
                </div>
              ))}
            </div>
          </div>

          {/* FINAL CTA */}
          <div className="about-section about-final collab-final">

            <p className="text-center" style={{textAlign:"center",marginTop:"20px"}}>
              At Aethearia, we help create atmosphere with intention.
            </p>

            <Link to="/contact" className="collab-contact-btn" style={{textAlign:"center",marginBottom:"20px"}}>
              Get In Touch
              {/* <span aria-hidden="true">→</span> */}
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default CollectionsPage;